import { useMemo, useState } from "react";

interface InputImagesProps {
  label: string;
  images: { s3_path: string; url: string }[];
  onImageClick: (url: string) => void;
}

const InputImages: React.FC<InputImagesProps> = ({ label, images, onImageClick }) => {
  const [failedUrls, setFailedUrls] = useState<Set<string>>(new Set());
  const displayImages = useMemo(() => images.filter((img) => img.url), [images]);

  if (!images.length) return null;
  const markFailed = (url: string) => setFailedUrls((prev) => new Set(prev).add(url));

  return (
    <div>
      <div className="prompt-label">{label}</div>
      <div className="input-imgs-row">
        {displayImages.length === 0 && <div className="input-thumb-fallback">No available image URLs</div>}
        {displayImages.map((img, i) => {
          const hasFailed = failedUrls.has(img.url);
          return (
            <button
              key={`${img.s3_path || img.url}-${i}`}
              type="button"
              onClick={() => onImageClick(img.url)}
              className="input-thumb-button"
              disabled={hasFailed}
              title={hasFailed ? img.s3_path : undefined}
            >
              {hasFailed ? (
                <span className="input-thumb-fallback">Image unavailable</span>
              ) : (
                <img
                  src={img.url}
                  alt={`${label} ${i + 1}`}
                  className="input-thumb"
                  loading="lazy"
                  decoding="async"
                  onError={() => markFailed(img.url)}
                />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default InputImages;
